<script>
    import { fetchGet, fetchPatch } from "../utils/utilsFetch.js";

    import { messageObject, isLoading } from "../stores.js";

    let password;

    async function changePassword() {
        await fetchPatch(`/api/password`, {
            password,
        });
        password = "";

        $messageObject = {
            showMessage: true,
            type: "success",
            message: "Uspjesno promenjena lozinka.", // Успешно променета лозинка
        };
    }
</script>

<div class="container">
    <div class="form">
        <input
            type="password"
            placeholder="Nova Lozinka"
            bind:value={password}
        />

        <button class="btn btn-blue" on:click={changePassword}>
            Промени
        </button>
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: column;
        padding: 20px;
    }

    .form {
        display: flex;
    }

    .form button {
        margin-left: 10px;
    }
</style>
